import { useQuery } from '@tanstack/react-query';

import { CACHE_DURATIONS } from 'src/utils/constants';

import axios from 'src/lib/axios';
import { FEATURE_FLAGS } from 'src/global-config';

export async function getKnowledgeBases() {
  const response = await axios.get('/api/knowledge-bases');
  return response.data;
}

export const useGetKnowledgeBases = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['knowledge-bases'],
    queryFn: getKnowledgeBases,
    refetchOnMount: false,
    staleTime: CACHE_DURATIONS.LONG,
    enabled: FEATURE_FLAGS.enableKnowledgeBase === 'true',
  });

  return {
    knowledgeBases: data?.items || [],
    isLoading,
    error,
  };
};
